import React, { useState } from 'react'
import { AutoComplete, Button, Flex, Form, Grid, Input, Space } from 'antd'
import { AimOutlined } from '@ant-design/icons'
import { get } from '../../../../Common/api'
import { Color } from '../../../../Common/Color'
import { useForm } from 'antd/es/form/Form'
import { t } from 'i18next'
const { useBreakpoint } = Grid

const highlight = (text, highlight) => {
  const parts = text.split(new RegExp(`(${highlight})`, 'gi'))
  return <span> {parts.map((part, i) =>
    <span key={i} style={part.toLowerCase() === highlight.toLowerCase() ? { color: Color.red } : {}}>
      {part}
    </span>)
  } </span>
}

const renderItem = (e, search) => ({
  value: `${e.normalized_name} ${e.zip_code}`,
  key: e.id,
  extra: e,
  label: (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      {highlight(e.normalized_name, search)}
      <span> {highlight(e.zip_code, search)} </span>
    </div>
  )
})

export default function ComputerSearch () {
  const [options, setOptions] = useState([])
  const [selectedOption, setSelectedOption] = useState()
  const [loading, setLoading] = useState(false)
  const [form] = useForm()
  const screens = useBreakpoint()

  const fieldStyle = {
    xs: { width: '200px' },
    other: { width: '21em' }
  }

  const onFinish = () => {
    if (selectedOption) {
      // Force browser navigation to set cookie
      window.location.href = `/results?lat=${selectedOption.lat}&long=${selectedOption.long}`
    }
    setLoading(false)
  }

  const onFinishFailed = () => {
    setLoading(false)
  }

  const handleSearch = (search, latitude, longitude, callback) => {
    get({
      url: 'public/postal_places',
      params: { search, lat: latitude || '', long: longitude || '' },
      onSuccess: (json) => {
        const newOptions = json.map((e) => renderItem(e, search))
        setOptions(newOptions)
        if (callback) {
          callback(json)
        }
      }
    })
  }

  const geoLoc = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (position) {
        handleSearch('', position.coords.latitude, position.coords.longitude, (json) => {
          form.setFieldsValue({ search: json[0].normalized_name })
          setOptions([])
          setSelectedOption(json[0])
        })
      })
    }
  }

  const onSelect = (value, option) => {
    setSelectedOption(option.extra)
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && selectedOption) {
      e.preventDefault()
      form.submit()
    }
  }
  return (
  <Flex vertical>
    <div style={{ fontWeight: 'bold', fontSize: '21px' }}>
      {t('Public.Search.title')}
    </div>
    <Form
      form={form}
      name="basic"
      onFinish={onFinish}
      autoComplete="off"
      layout="inline"
      onFinishFailed={onFinishFailed}
    >
      <Form.Item
        style={ screens.xs ? fieldStyle.xs : fieldStyle.other }
        name="search"
        rules={[{ required: true, message: t('Public.Search.required') }]}
      >
        <Space.Compact style={{ width: '20em' }}>
          <AutoComplete
            popupMatchSelectWidth={350}
            options={options}
            showSearch={{ onSearch: handleSearch }}
            onSelect={(value, option) => onSelect(value, option)}
          >
            <Input autoFocus={true} placeholder={t('Public.Search.placeholder')} onKeyDown={handleKeyDown} />
          </AutoComplete>
          <Space.Addon style={{ borderRadius: '0 10px 10px 0' }}>
              <AimOutlined onClick={geoLoc} disabled={loading} />
          </Space.Addon>
        </Space.Compact>
      </Form.Item>
      <Form.Item >
        <Button type="primary" htmlType="submit" onClick={() => setLoading(true)} loading={loading}>
          {t('actions.validate')}
        </Button>
      </Form.Item>
    </Form>
  </Flex>
  )
}
